import React from 'react';
import { ImagesProvider } from '../../components/ProductImage/ImagesProvider';
import { ProductOptionEditorProvider } from '../../context/ProductOptionEditorContext';
import { ProductVariantEditorProvider } from '../../context/ProductVariantEditorContext';
import { DeliveryProfileProvider } from '../../components/DeliveryProfileEditor';

/**
 * The stack of context providers the product editor depends on. Extracted so the
 * top-level `Product` component reads as a flat load-guard + form, rather than a
 * deeply nested provider pyramid.
 */
export const ProductEditorProviders: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <ImagesProvider>
    <ProductOptionEditorProvider>
      <ProductVariantEditorProvider>
        <DeliveryProfileProvider>{children}</DeliveryProfileProvider>
      </ProductVariantEditorProvider>
    </ProductOptionEditorProvider>
  </ImagesProvider>
);
